module.exports = __webpack_public_path__ + "img/ill-home-services-designing.3f516b6a.svg";